import {_} from 'lodash';
import * as ko from "knockout";
import {IObjectSearchParams, template as tpl, viewModel as ObjectSearch} from "../search";
import {IObjectData} from "../../../index";
import {ObjectTypeId} from "../../../constants";

export let template = tpl;

export class viewModel extends ObjectSearch {

    constructor(params: IObjectSearchParams) {
        super(_.defaults(params, {objecttypeid: ObjectTypeId.User}));
    }

    protected override onRowClick(item: IObjectData) {
        if (this.params.fnValidateRow && !this.params.fnValidateRow(item)) {
            return;
        }
        this.getItemCheckbox(item).toggle()
    }

    override showOperationsButton(): boolean {
        return false;
    }

    override showTableColumn(key: string): boolean {
        if (key == 'func') {
            return false;
        }
        return super.showTableColumn(key);
    }

    protected override showSelectedList = ko.pureComputed((): boolean => {
        return false;
    });

}